'use client'

import { useRef, useState } from 'react'
import { Band, DISPLAY_H2 } from './band'
import { RevealText } from './reveal-text'
import { ctaClassName } from './ui/cta'

/**
 * The product video, carried over from the old homepage: click to play, inside the same
 * browser frame as the other screens. The file is hosted on the one media origin the
 * CSP allows. No captions track exists yet; adding one is on the follow-up list.
 */
const VIDEO_SRC =
  'https://whvideo.ams3.cdn.digitaloceanspaces.com/-MAIN%20COMP_5.mp4'

export function VideoSection() {
  const video = useRef<HTMLVideoElement | null>(null)
  const [playing, setPlaying] = useState(false)

  const play = () => {
    setPlaying(true)
    void video.current?.play()
  }

  return (
    <Band id="video" tone="muted">
      <div className="max-w-3xl">
        <RevealText className={DISPLAY_H2} text="See it *running*." />
        <p className="mt-6 text-lg leading-relaxed text-ink-muted">
          Less than two minutes on a more detailed look at our system.
        </p>
      </div>
      <div className="mx-auto mt-12">
        <div className="device-frame overflow-hidden rounded-card border border-line bg-surface">
          <div className="relative aspect-[960/459] w-full bg-ink-deep">
            <video
              className="absolute inset-0 size-full object-cover"
              controls={playing}
              data-testid="video-player"
              muted
              playsInline
              preload="metadata"
              ref={video}
              src={VIDEO_SRC}
            >
              <track kind="captions" />
            </video>
            {!playing ? (
              <div className="absolute inset-0 flex items-center justify-center">
                <button
                  className={ctaClassName({ size: 'lg' })}
                  onClick={play}
                  type="button"
                >
                  Watch the video
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Band>
  )
}
